package com.cybersoftsolution.cybersoftsolutionweb.components.navigation

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.components.icons.MyFaIcon
import com.cybersoftsolution.cybersoftsolutionweb.components.icons.VectorIcon
import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.selectedColor
import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.unselectedColor
import com.cybersoftsolution.cybersoftsolutionweb.styles.NavigationItemStyleCss
import com.cybersoftsolution.cybersoftsolutionweb.styles.Scale_Selected_ItemStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.Selected_ItemStyle
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.icons.fa.FaIcon
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

@Composable
fun NavigationItemNew(
    modifier: Modifier = Modifier.fillMaxWidth(),
    selected: Boolean = false,
    title: String,
    icon: String? = null,
    onClick: () -> Unit,
){



    Row(
        modifier = Selected_ItemStyle.toModifier()
            .margin(bottom = 20.px)
            .then(modifier)
            .cursor(Cursor.Pointer)
            .onClick { onClick() }
            .transition(
                Transition.of(
                    property = TransitionProperty.All,
                    duration = 300.ms
                )
            )
        ,
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically
    ){


        icon?.let {
            MyFaIcon(
                id = "menuIcon${title.replace(" ","").trimIndent()}",
                faIconsClassName = Resources.FaIconsClassName.AdminPanel_ICO ,
                size = 32,
//                color = if (selected) {
//                    selectedColor
//                } else {
//                    unselectedColor
//                },
            )
        }

        SpanText(
            text = title,
            modifier = Modifier
                .thenIf(
                    condition = icon != null,
                    other = Modifier.margin(left = 15.px)
                )
                .id(IdConst.navigationText+selected.toString())
                .fontSize(16.px)
                .fillMaxWidth()
//                .fontFamily("serif")
        )

    }

//    Row(
//        modifier = NavigationItemStyleCss.toModifier()
//            .then(modifier)
//            .cursor(Cursor.Pointer)
//            .margin(bottom = 20.px)
//            .onClick { onClick() },
//        verticalAlignment = Alignment.CenterVertically
//
//    ){
//
//
//
//        MyFaIcon(
//            style = NavigationItemStyleCss,
//            id = IdConst.navigationIcon,
//            modifier = Modifier.margin(right = 10.px),
//            size = 32,
//            faIconsClassName = Resources.FaIconsClassName.AdminPanel_ICO,
//            color = if (selected) {
//                selectedColor
//            } else {
//                unselectedColor
//            },
//        )
//
////        VectorIcon(
////            modifier = .toModifier()
////                .margin(right = 10.px)
////                .id(),
////            pathData = icon,
//
////            size = 48
////        )
//
//
//        SpanText(
//            text = title,
//            modifier = NavigationItemStyleCss.toModifier()
//                .id(IdConst.navigationText+selected.toString())
//                .fontSize(16.px)
//                .fillMaxWidth()
//        )
//
//
//    }

}